module.exports = __webpack_public_path__ + "media/images/common/kuchi_3-277c4886be522e167549670bd49e3804.gif";